import { FOXES_GIG_FOURTH_PACKAGE } from '../experimentsEnum';
import { inAbTest } from '..';

export default (abTests) => inAbTest(abTests, FOXES_GIG_FOURTH_PACKAGE);
